import { Link } from 'react-router-dom'; 
import './../LegalPage.css';
const HeaderHyfye = () => {
    return ( 
    <> <div className="container-fluid">
    	<nav className="navbar navbar-expand-lg nav-fixed"> 
             <Link className="navbar-brand page-scroll animation logo" to="/#home_section" data-animation="fadeInDown" data-animation-delay="0.1s"> 
            	  <img className="logo_dark App-logo" loading="lazy" src="https://pub-ba546ddaa1784315aecd8b5bd97af3a2.r2.dev/images/web/logo-dark.png" alt="logo" /> 
                <img className='logo_light App-logo' loading="lazy" src='https://pub-ba546ddaa1784315aecd8b5bd97af3a2.r2.dev/images/web/logo-white.png' alt='logo'/>
             </Link>
             <h4>Hyfye Privacy & Terms</h4>
             </nav> </div>  

      
       </>
)};

export default HeaderHyfye;